import {
  requestSensitiveDataEndpoint,
  reviewSensitiveDataEndpoint,
} from '../constants/endpoints';
import { APIEntityType, APISensitiveDataResponseStatus } from '../types/api';
import { httpMethod } from '../utils/sra';

export type CoreSensitiveData = {
  requestSensitiveDataPending?: boolean;
  reviewSensitiveDataPending?: boolean;
};

export const coreSensitiveDataState: CoreSensitiveData = {
  requestSensitiveDataPending: false,
  reviewSensitiveDataPending: false,
};

const requestSensitiveData = (
  providerId: string,
  entityType: APIEntityType,
  entityId: string | number,
) => ({
  name: 'requestSensitiveData',
  url: requestSensitiveDataEndpoint(providerId, entityType, entityId),
  method: httpMethod.post,
});

const reviewSensitiveData = (
  providerId: string,
  entityType: APIEntityType,
  entityId: string | number,
  body: APISensitiveDataResponseStatus,
) => ({
  name: 'requestSensitiveData',
  url: reviewSensitiveDataEndpoint(providerId, entityType, entityId),
  method: httpMethod.post,
  body,
});

export const coreSensitiveDataMethods = {
  requestSensitiveData,
  reviewSensitiveData,
};
